import LockIcon from "@mui/icons-material/Lock";
import { MenuItem, Stack, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { IChangePassword } from "./models";

export const ChangePassword = memo(({ openModalHandler }: IChangePassword) => {
  const { t } = useTranslation();

  return (
    <MenuItem onClick={openModalHandler}>
      <Stack direction={"row"} spacing={1}>
        <LockIcon color="action" />
        <Typography>{t("change_password")}</Typography>
      </Stack>
    </MenuItem>
  );
});
